<app-navbar></app-navbar>
<div class="container py-5">
    <h2 style="margin-bottom: 25px;">Políticas de Privacidad - PRAD Academy</h2>
    <div class="row">
        <div class="col-md-12">
            <mat-card [appearance]="'outlined'">
                <mat-card-content>

                    <p>En PRAD Academy, valoramos su confianza y protegemos su información personal conforme a los más
                        altos estándares de privacidad y seguridad.</p>

                    <p>Su tratamiento de datos es el siguiente: la información que usted proporciona se utiliza
                        exclusivamente para gestionar su registro, participación en cursos, emisión de certificados y
                        comunicaciones académicas o informativas.</p>

                    <p>Los datos son tratados de forma confidencial, almacenados en servidores seguros y nunca se
                        comparten con terceros sin su consentimiento expreso, salvo obligación legal.</p>

                    <p>Para más detalles, queremos que comprenda cómo procesamos sus datos y también que conozca sus
                        derechos y opciones.</p>

                    <h4>1. Identidad del Responsable del Tratamiento</h4>
                    <p>PRAD Academy (en adelante, “la Plataforma”) es responsable del tratamiento y protección de los
                        datos personales proporcionados por los usuarios a través del sitio web, formularios de
                        registro, y cualquier otro medio electrónico relacionado con sus servicios de formación en
                        línea.</p>
                    <ul>
                        <li>Correo de contacto: <a href="mailto:pradacademy.cr@gmail.com">pradacademy.cr@gmail.com</a>
                        </li>
                        <li>Sitio web oficial: <a href="https://pradacademy.com"
                                target="_blank">https://pradacademy.com</a></li>
                    </ul>

                    <h4>2. Tratamiento de los Datos Personales</h4>
                    <h5>A. Los datos personales recabados serán tratados para las siguientes finalidades:</h5>
                    <ul>
                        <li>Gestionar el proceso de registro, acceso y participación del usuario en los cursos ofrecidos
                            por la Plataforma.</li>
                        <li>Emitir certificados de aprobación correspondientes al curso recibido.</li>
                        <li>Facilitar la comunicación entre el usuario y la Plataforma para notificaciones, soporte
                            técnico y actualización de información académica.</li>
                        <li>Administrar facturación y comprobantes de las transacciones realizadas.</li>
                        <li>Cumplir con obligaciones legales, contractuales y administrativas derivadas de la relación
                            con el usuario.</li>
                    </ul>
                    <h5>B. Los datos personales recabados NO serán tratados para las siguientes finalidades:</h5>
                    <ul>
                        <li>Realizar encuestas de satisfacción y análisis estadísticos para la mejora de los servicios.
                        </li>
                        <li>Enviar comunicaciones informativas o promocionales sobre nuevos cursos, programas o
                            actividades académicas.</li>
                    </ul>

                    <h4>3. Datos Personales que se recaban</h4>
                    <p>Para la emitir los certificados de aprobación, soporte técnico o comunicados académicos, PRAD
                        Academy solicitará los siguientes datos:</p>
                    <ul>
                        <li>Datos de identificación: nombre completo, documento de identidad.</li>
                        <li>Datos de contacto: dirección de correo electrónico, número telefónico (opcional).</li>
                        <li>Datos académicos: historial de cursos, calificaciones, certificados emitidos.</li>
                        <li>Datos de pago: información de facturación y comprobantes de pago.</li>
                    </ul>

                    <h4>4. Base Legal y Consentimiento</h4>
                    <p>El tratamiento de los datos personales se realiza conforme al consentimiento libre, expreso e
                        informado del titular, otorgado al registrarse y utilizar los cursos de la Plataforma.</p>

                    <h4>5. Medidas de Seguridad</h4>
                    <p>PRAD Academy implementa medidas técnicas, administrativas y organizativas apropiadas para
                        garantizar la confidencialidad, integridad y disponibilidad de los datos personales.</p>
                    <p>Los datos son tratados de forma confidencial, almacenados en servidores seguros y nunca se
                        comparten con terceros sin su consentimiento expreso, salvo obligación legal.</p>
                    <p>Los datos sensibles (como los de pagos) NO son realizados mediante la Plataforma, sino que cada
                        usuario lo realiza particularmente según el método que use. PRAD Academy, solamente registra el
                        comprobante de pago efectuado por el usuario.</p>

                    <h4>6. Conservación de los Datos</h4>
                    <p>PRAD Academy conservará los datos personales de los usuarios durante el tiempo necesario para
                        mantener el historial académico, la validez de los certificados emitidos y el cumplimiento de
                        los requisitos de renovación de cursos, los cuales deben ser cada 2 años conforme a la normativa
                        nacional y a los estándares de capacitación continua en protección radiológica.</p>
                    <p>Dicha información se mantendrá activa y resguardada en nuestros sistemas mientras el usuario
                        mantenga una relación académica o administrativa con la Plataforma, o mientras sea necesario
                        para fines legales, de auditoría o verificación de certificaciones emitidas.</p>
                    <p>No obstante, el usuario podrá solicitar la eliminación o cancelación de sus datos personales,
                        conforme al procedimiento establecido en el punto 7 (Derechos de los Titulares de los Datos), en
                        cuyo caso PRAD Academy procederá a su supresión segura, salvo cuando exista una obligación legal
                        o administrativa que requiera su conservación por un período adicional.</p>

                    <h4>7. Derechos de los Titulares de los Datos</h4>
                    <p>El titular de los datos personales tiene derecho a:</p>
                    <ul>
                        <li><strong>Acceder</strong> a la información que sobre él posee la Plataforma.</li>
                        <li><strong>Rectificar</strong> sus datos cuando sean inexactos o incompletos.</li>
                        <li><strong>Cancelar o suprimir</strong> sus datos cuando haya finalizado el curso o no sean necesarios para los
                            fines declarados.</li>
                    </ul>
                    <p>El ejercicio de estos derechos podrá realizarse mediante solicitud escrita dirigida al correo: <a
                            href="mailto:pradacademy.cr@gmail.com">pradacademy.cr@gmail.com</a>, indicando nombre
                        completo, medio de contacto y el derecho que desea ejercer.</p>
                    <p>PRAD Academy responderá con un máximo de 5 días naturales.</p>

                    <h4>8. Transferencia y Comunicación de Datos a Terceros</h4>
                    <p>PRAD Academy NO compartirá datos personales con terceros, salvo en los siguientes casos:</p>
                    <ul>
                        <li>Cuando exista una obligación legal, administrativa o judicial que así lo requiera.</li>
                        <li>Cuando el usuario haya otorgado su consentimiento expreso.</li>
                    </ul>
                    <p>En tales casos, se garantizará que los terceros receptores cuenten con políticas y niveles
                        adecuados de protección de datos personales.</p>

                    <h4>9. Modificaciones a la Política de Privacidad</h4>
                    <p>PRAD Academy se reserva el derecho de modificar la presente Política de Privacidad para adaptarla
                        a cambios legislativos, tecnológicos o de operación de la Plataforma.</p>
                    <p>Cualquier modificación será publicada en el sitio web con la fecha de última actualización, y
                        entrará en vigor a partir de su publicación.</p>
                    <p><strong>Última actualización:</strong> 25 de octubre de 2025</p>

                    <h4>10. Contacto</h4>
                    <ul>
                        <li>📧 Correo: <a href="mailto:pradacademy.cr@gmail.com">pradacademy.cr@gmail.com</a></li>
                        <li>🌐 Sitio web: <a href="https://pradacademy.com" target="_blank">https://pradacademy.com</a>
                        </li>
                        <li>🏛️ Entidad responsable: PRAD Academy</li>
                    </ul>



                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
<app-footer></app-footer>